import React, { Component } from 'react';
import { Grid, Icon, Form, Button, Segment, Dropdown, Label } from 'semantic-ui-react';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import { exportXLSX } from '../../utils/rest';
import ReactTable from 'react-table';
import Loading from '../Loading';
import { fileTypeList } from '../../utils/defaults';
import validation from '../../components/SimpleReactValidation';
import Dropzone from 'react-dropzone';
import { uploadEdiFile, getUploadedEdiFile, downloadEdiFile } from '../../utils/rest';
import { NotificationManager } from 'react-notifications';

class EDIUpload extends Component {
    constructor(props) {
        super(props);
        this.validator = validation();
        this.state = {
            loading: false,
            isNewAccountRestricted: this.props._menuIsRestricted(this.props.items.menuItems, 1, 9),
            cltClientIds: "",
            efuFileType: "",
            efuComments: "",
            efuTotalAccounts: "",
            efuTotalAmount: "",
            file: null,
            uploadDetails: [],
            uploadedDetails: []
        };
    }

    componentDidMount() {
        this.getUploadedEdiFiles();
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    componentDidUpdate(prevProps) {
        if (this.props.items.currentCorporate !== prevProps.items.currentCorporate) {
            this.getUploadedEdiFiles();
        }

    }

    getUploadedEdiFiles = () => {
        getUploadedEdiFile(this.props.items.currentCorporate).then((response) => {
            if (response !== null && response instanceof Array) {
                this.setState({
                    loading: false,
                    uploadedDetails: response
                })
            }
        });
    }

    handleChange = (e) => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        });
    }

    handleChangeList = (e, evt) => {
        this.setState({
            ...this.state,
            [evt.name]: evt.value
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({
                loading: true
            }, () => {
                const data = new FormData()
                data.append("efuCorporateId", this.props.items.currentCorporate);
                data.append("efuClientId", this.state.cltClientIds);
                data.append("efuFileName", this.state.efuFileName);
                data.append("efuFileType", this.state.efuFileType);
                data.append("efuTotalAccounts", this.state.efuTotalAccounts);
                data.append("efuTotalAmount", this.state.efuTotalAmount);
                data.append("efuComments", this.state.efuComments);
                data.append('file', this.state.file);
                uploadEdiFile(this.props.items.currentCorporate, data).then((response) => {
                    if (response !== null && response instanceof Array) {
                        NotificationManager.success('Success', 'File uploaded successfully.');
                        this.setState({
                            loading: false,
                            cltClientIds: "",
                            efuFileType: "",
                            efuComments: "",
                            efuTotalAccounts: "",
                            efuTotalAmount: "",
                            file: null,
                            uploadDetails: [],
                            uploadedDetails: response
                        })
                    }
                }).then(() => {
                    this.setState({
                        loading: false,
                        cltClientIds: "",
                            
                    });
                });
            });
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.forceUpdate();
        }
    }

    onDrop = (files) => {
        var allow = true;
        let excludeFileType = [".exe", ".zip"];
        let filename = files[0].name;
        for (let i = 0; i < excludeFileType.length; i++) {
            if (filename.indexOf(excludeFileType[i]) >= 0) {
                allow = false; break;
            }
        }
        if (allow) {
            // do stuff with files…
            this.setState({
                file: files[0],
                uploadDetails: [{
                    filename: filename
                }]
            });
        } else {
            NotificationManager.info('Info', 'File types not allowed.');

        }
    }

    downloadEdiFile = (id) => {
        downloadEdiFile(this.props.items.currentCorporate, id).then((response) => {
            if (response !== null) {
                let disposition = response.request.getResponseHeader('Content-Disposition');
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    let matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        let filename = matches[1].replace(/['"]/g, '');
                        if (typeof window.navigator.msSaveBlob !== 'undefined') {
                            // IE workaround for "HTML7007: One or more blob URLs were 
                            // revoked by closing the blob for which they were created. 
                            // These URLs will no longer resolve as the data backing 
                            // the URL has been freed."
                            window.navigator.msSaveBlob(new Blob([response.data]), filename);
                        } else {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', filename);
                            document.body.appendChild(link);
                            link.click();
                        }
                    }
                }
            }
        });
    }

    render() {
        return (
            <div>
                {(this.state.loading) ? <Loading /> : ""}
                <BreadcrumbCustom {...this.props} parent="Account Management" child={[{ name: "EDI File Upload", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Form className="small">
                                <Form.Group>
                                    <Form.Field width={4} className="required">
                                        <label>Select Client ID(s):</label>
                                        <Dropdown placeholder='Select Client ID(s)' className="fluid" search selection options={this.props.items.clients.map((client) => { client.disabled = !client.allowedtocancelaccount; return client; })} name="cltClientIds" value={this.state.cltClientIds} onChange={this.handleChangeList} ></Dropdown>
                                        {this.validator.message('Client ID(s)', this.state.cltClientIds, 'required')}
                                    </Form.Field>
                                    <Form.Field width={4}>
                                        <label>File Type:</label>
                                        <Dropdown placeholder='Select file type' className="fluid" selection options={fileTypeList} value={this.state.efuFileType} onChange={this.handleChangeList} name="efuFileType"></Dropdown>
                                    </Form.Field>
                                    <Form.Field width={4}>
                                        <label># of Accounts:</label>
                                        <Form.Input placeholder='Enter # of Accounts' onChange={this.handleChange} value={this.state.efuTotalAccounts} name="efuTotalAccounts" />
                                        {this.validator.message('Enter # of Accounts', this.state.efuTotalAccounts, 'numeric')}
                                    </Form.Field>
                                    <Form.Field width={4}>
                                        <label>Amount of Accounts:</label>
                                        <Form.Input placeholder='Enter Amount of Accounts' onChange={this.handleChange} value={this.state.efuTotalAmount} name="efuTotalAmount" />
                                        {this.validator.message('Enter Amount of Accounts', this.state.efuTotalAmount, 'currency')}
                                    </Form.Field>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Field width={4} >
                                        <label>Comments:</label>
                                        <Form.TextArea rows="2" name="efuComments" placeholder='Type Comments' value={this.state.efuComments} onChange={this.handleChange} />
                                    </Form.Field >
                                    <Form.Field width={4} className="required">
                                        <label>File Upload:</label>
                                        <Dropzone ref="dropzone" multiple={false} style={{
                                            position: "relative",
                                            height: "50px",
                                            borderWidth: "2px",
                                            borderColor: "rgb(102, 102, 102)",
                                            borderStyle: "dashed",
                                            borderRadius: "5px",
                                            textAlign: "center",
                                            display: "none"
                                        }} onDrop={(files) => this.onDrop(files)}>
                                            Try dropping some files here, or click to select files to upload.
                                                                            </Dropzone>
                                        <Button
                                            icon="upload"
                                            label={{
                                                basic: true,
                                                content: 'Browse file to upload'
                                            }}
                                            labelPosition="right"
                                            onClick={() => { this.refs.dropzone.open(); }}
                                        />
                                        {
                                            (() => {
                                                // eslint-disable-next-line
                                                return this.state.uploadDetails && this.state.uploadDetails.map((upload, index) => {
                                                    return (
                                                        <Label as='a' key={index}>
                                                            {upload.filename}
                                                            <Icon name='delete' onClick={() => this.setState((prevState, props) => {
                                                                return {
                                                                    uploadDetails: []
                                                                };
                                                            })} />
                                                        </Label>
                                                    )
                                                })
                                            })()
                                        }
                                        {this.validator.message('File', this.state.file, 'required')}
                                    </Form.Field >
                                    <Form.Field width={2} >
                                        <Button.Group className="small push-down">
                                            <Button onClick={() => this.setState((prevState, props) => {
                                                return {
                                                    cltClientIds: "",
                                                    efuFileType: "",
                                                    efuComments: "",
                                                    efuTotalAccounts: "",
                                                    efuTotalAmount: "",
                                                    file: null,
                                                    uploadDetails: []
                                                };
                                            })}>{this.props.t("reset")}</Button>
                                            <Button.Or />
                                            <Button positive onClick={this.handleSubmit}>{this.props.t("submit")}</Button>
                                        </Button.Group>
                                    </Form.Field >
                                </Form.Group>
                            </Form>
                            <Segment.Group>
                                <Segment raised color="grey" inverted>
                                    <h4 className="ui header">
                                        <Icon name="search" />
                                        <div className="content">
                                            View Past Submission
                                            </div>
                                        <div className="right floated content push-up small-font">
                                        </div>
                                    </h4>
                                </Segment>
                                <Grid className="margin-bottom-5">
                                    <Grid.Column width={1} floated='right' className="remvespace-btm">
                                        <Button onClick={() => {
                                            exportXLSX(
                                                {
                                                    "Date": "efuCreatedAt",
                                                    "File Name": "efuFileName",
                                                    "File Type": "efuFileType",
                                                    "# of Accounts": "efuTotalAccounts",
                                                    " Amount of Accounts": "efuTotalAmount",
                                                    "Comments": "efuComments",
                                                    "Uploaded By?": "efuCreatedUser"
                                                }, this.state.uploadedDetails, "EDIUpload.xlsx")
                                        }}
                                            className="ui left small icon button icon-export" data-inverted="" data-tooltip="Export Table Details to Spreadsheet" data-position="bottom right">
                                            <i className="file excel icon"></i>
                                        </Button>
                                    </Grid.Column>
                                </Grid>
                                <ReactTable noDataText={null} minRows={0} defaultPageSize={this.props.reactTable().pageSize} showPagination={this.state.uploadedDetails.length > this.props.reactTable().pageSize ? true : false} filterable defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                                    data={this.state.uploadedDetails}
                                    getNoDataProps={() => {
                                        return { style: { display: 'none' } };
                                    }}
                                    columns={[
                                        {
                                            Header: "#",
                                            maxWidth: 50,
                                            filterable: false,
                                            Cell: (row) => {
                                                return <div>{row.index + 1}</div>;
                                            }
                                        },
                                        {
                                            Header: props => <span data-inverted="" data-tooltip="Date" data-position="bottom left">Date</span>,
                                            id: 'efuCreatedAt',
                                            width: 100,
                                            accessor: row => (
                                                this.props._timeStampToDate(row.efuCreatedAt)
                                            )
                                        }, {
                                            Header: props => <span data-inverted="" data-tooltip="Our Client Identifier" data-position="bottom left">Client ID</span>,
                                            accessor: 'efuClientId',
                                            width: 100,
                                        }, {
                                            Header: props => <span data-inverted="" data-tooltip="Uploaded File name" data-position="bottom left">File Name</span>,
                                            accessor: 'efuFileName',
                                            minWidth: 250,
                                        }, {
                                            Header: props => <span data-inverted="" data-tooltip="File Extension" data-position="bottom left">File Type</span>,
                                            accessor: 'efuFileType',
                                            width: 80,
                                        }, {
                                            Header: props => <span data-inverted="" data-tooltip="Total Accounts" data-position="bottom left"># of Accounts</span>,
                                            accessor: 'efuTotalAccounts',
                                            width: 100,
                                            style: {
                                                textAlign: "right"
                                            }
                                        }, {
                                            Header: props => <span data-inverted="" data-tooltip="Total Amount of all Accounts" data-position="bottom left"> Amount of Accounts</span>,
                                            id: 'efuTotalAmount',
                                            width: 150,
                                            style: {
                                                textAlign: "right"
                                            },
                                            accessor: row => (
                                                (row.efuTotalAmount) ? this.props._currencyFormat(row.efuTotalAmount) : 0.00
                                            )
                                        }, {
                                            Header: props => <span data-inverted="" data-tooltip="Comments" data-position="bottom left">Comments</span>,
                                            accessor: 'efuComments',
                                            minWidth: 150
                                        }, {
                                            Header: props => <span data-inverted="" data-tooltip="Uploaded user" data-position="bottom left">Uploaded By?</span>,
                                            accessor: 'efuCreatedUser',
                                            width: 150,
                                        }, {
                                            Header: props => <span data-inverted="" data-tooltip="Download" data-position="bottom right">Download</span>,
                                            filterable: false,
                                            width: 80,
                                            style: {
                                                textAlign: "center"
                                            },
                                            Cell: row => (
                                                <div>
                                                    <Button className="icon mini" data-inverted="" data-tooltip="Download the file" data-position="top right" onClick={() => { this.downloadEdiFile(row.original.efuId) }}><Icon name="download" /> </Button>
                                                </div>
                                            )
                                        }]}
                                />
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div >
        );
    }
}
export default EDIUpload;


// WEBPACK FOOTER //
// ./src/app/ui/accounts/EDIUpload.js